import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../../createApiConfig';

export const lmAppsStoresApi = createApi({
  reducerPath: 'lmAppsStoresApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: [
    'AppStore',
  ],
  endpoints: builder => ({
    getAppStoresList: builder.query({
      query: (params) => ({
        url: `/links/app-stores/`,
        params,
      }),
      providesTags: ['AppStore'],
    }),
    createAppStore: builder.mutation({
      query: (data) => ({
        url: '/links/app-stores/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['AppStore'],
    }),
    getAppStoreById: builder.query({
      query: (id) => `/links/app-stores/${id}`,
      providesTags: ['AppStore'],
    }),
    updateAppStoreById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/app-stores/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['AppStore'],
    }),
  }),
});

export const {
  useGetAppStoresListQuery,
  useLazyGetAppStoresListQuery,
  useCreateAppStoreMutation,
  useGetAppStoreByIdQuery,
  useUpdateAppStoreByIdMutation,
} = lmAppsStoresApi;
